import { onNetworkError } from '@/infra/http/network-error-notifier'
import { getImmediateErrorMessage, resolveErrorMessage } from '@/presentation/helpers'
import { useEffect, useState } from 'react'
import { SnackbarApp } from './snackbar-app'

/**
 * Snackbar global para erros de rede. Ponto ÚNICO de UI para NetworkError em
 * todo o app: o query-client emite o erro (via notifier) e este componente
 * exibe a mensagem amigável — imediata (palpite síncrono) e depois refinada
 * pelo probe de conectividade (offline / proxy / inalcançável).
 */
export function NetworkErrorSnackbar() {
  const [message, setMessage] = useState<string | undefined>(undefined)

  useEffect(() => {
    // Evita setState após desmontar enquanto o probe (~3s) ainda está pendente.
    let active = true

    const unsubscribe = onNetworkError(async error => {
      if (!active) return
      const immediate = getImmediateErrorMessage(error)
      setMessage(immediate)

      const refined = await resolveErrorMessage(error)
      if (!active) return
      // Não reabre (se o usuário fechou) nem sobrescreve uma mensagem mais nova.
      setMessage(current => (current === immediate ? refined : current))
    })

    return () => {
      active = false
      unsubscribe()
    }
  }, [])

  // Mensagens de rede (ex.: proxyBlocked) são longas: tempo extra para leitura.
  return <SnackbarApp message={message} setMessage={setMessage} autoHideDuration={10000} />
}
